import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import SyncIcon from "@mui/icons-material/Sync";
import { useLoaderData, useNavigate } from "react-router-dom";

import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const InitialReviewFollowUpPage = ({ modifyPath }) => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData("root");
  const navigate = useNavigate();

  const headCells = [
    { id: "initialReviewReviewedAt", label: "تاریخ ثبت پیگیری", type: "date" },
    { id: "initialReviewOperatorFullName", label: "کارشناس بررسی" },
    { id: "fullName", label: "متقاضی" },
    { id: "mobile", label: "موبایل" },
    { id: "referenceID", label: "شناسه درخواست" },
    { id: "plantCapacityTitle", label: "ظرفیت" },
    { id: "adminComment", label: "یادداشت کارشناس" },
    { id: "requestConfirmTitle", label: "وضعیت" },
    {
      id: "actions",
      label: "عملیات",
      render: (_value, row) => (
        <IconButton
          size="small"
          title="مشاهده / تعیین تکلیف"
          onClick={(event) => {
            event.stopPropagation();
            navigate(`${modifyPath}/${row.id}`);
          }}
        >
          <ContentPasteSearchIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];

  const rows = (Array.isArray(dataList) ? dataList : []).map((row) => ({
    ...row,
    id: row.id ?? row.Id,
    initialReviewReviewedAt:
      row.initialReviewReviewedAt ?? row.InitialReviewReviewedAt,
    initialReviewOperatorFullName:
      row.initialReviewOperatorFullName ?? row.InitialReviewOperatorFullName ?? "—",
    fullName: row.fullName ?? `${row.firstName || ""} ${row.lastName || ""}`.trim(),
    mobile: row.mobile ?? row.Mobile ?? "—",
    referenceID: row.referenceID ?? row.ReferenceID ?? "—",
    plantCapacityTitle: row.plantCapacityTitle ?? row.PlantCapacityTitle ?? "—",
    adminComment: row.adminComment ?? row.AdminComment ?? "—",
    requestConfirmTitle: row.requestConfirmTitle ?? row.RequestConfirmTitle ?? "نیاز به پیگیری",
  }));

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title={pageInfo.title || "پیگیری بررسی اولیه"}
            subheader="درخواست‌هایی که از کارتابل بررسی اولیه خارج شده‌اند و نیاز به پیگیری دارند."
            action={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton color="primary" onClick={() => navigate(".")}>
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent sx={{ p: 0 }}>
            <EnhancedTable
              headCells={headCells}
              rows={rows}
              rowKey="id"
              onRowClick={(row) => navigate(`${modifyPath}/${row.id}`)}
              dense
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default InitialReviewFollowUpPage;
